import { Tab, Tabs } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import OvertimeSettings from './overtimeSettings';
import WeeklyOvertimeSettings from './weeklyOvertimeSettings';
import OvertimeCaps from './overtimeCaps';

const OvertimeSettingTabs = (props) => {
    const { t, handleUserDataChange } = props;
    return (
        <Tabs defaultActiveKey="overtimeSettings" id="MainTabContainer">
            <Tab eventKey="overtimeSettings" title={t('Overtime Settings')}>
                <OvertimeSettings handleUserDataChange={handleUserDataChange} />
            </Tab>
            <Tab eventKey="weeklyOvertimeSettings" title={t('Weekly overtime Settings')}>
                <WeeklyOvertimeSettings />
            </Tab>
            <Tab eventKey="overtimeCaps" title={t('Overtime Caps')}>
                <OvertimeCaps />
            </Tab>
        </Tabs>
    )
}

export default withLocalization(OvertimeSettingTabs);